<template>
    <nav class="footer-category">
        <slot name="title"/>
        <slot name="content" class="footer-category--list"/>
    </nav>
</template>

<script>
    export default {
        props: {},
    };
</script>
